import { useEffect, useState } from 'react';
import { selectedTheme, subscribeTheme, unsubscribeTheme } from './theme';
var useTheme = function () {
    var _a = useState(selectedTheme), theme = _a[0], setTheme = _a[1];
    useEffect(function () {
        subscribeTheme(setTheme);
        return function () { return unsubscribeTheme(setTheme); };
    }, []);
    return theme;
};
export default useTheme;
